import { useRef, useState } from "react";
import { Button } from "../components/Elements";
import Filters from "../components/CronJobRecords/Filters";
import RecordTable from "../components/CronJobRecords/RecordTable";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { buttonTexts } from "../../constants/texts/buttonTexts";
import { exportExcelHelper } from "../../common/helpers/exportExcelHelper";
import { useSelector } from "react-redux";
import { RootStateType } from "../../store/RootState";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";

const CronJobRecords = () => {
    usePermissionCheck(UserOperationTypes["Erp Entegrasyonu"], "Zamanlanmış Görevler İşlemleri izni yok");
    const reportTableRef = useRef<any>();

    const [filtersIsOpen, setFiltersIsOpen] = useState<boolean>(true);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const [headCells, setHeadCells] = useState<any[]>([])

    const { cronJobRecordList } = useSelector((state: RootStateType) => state.cronJobRecordList); 

    const exportToExcelClick = async () => {

        setExcelLoading(true);
        try {
            exportExcelHelper(cronJobRecordList, "id", reportTableRef, headCells, "Zamanlanmış_Aktarım_Kayıtları");
        } catch (error) {

        } finally {
            setExcelLoading(false);
        }
    }

    const handleHeadCells = (values: any) => {
        setHeadCells(values);
    }

    return (
        <div className="w-full">
            <PageTitle title={pageTitleTexts.cronJobRecords} />

            <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
                <div className="flex flex-row items-center">
                    <img src={"/icons/zamanlanmis-gorevler-dark.svg"} className="h-6 w-6 black" />
                    <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                        Zamanlanmış Aktarım Kayıtları
                    </span>
                </div>

                <div className=" flex flex-row justify-end items-center px-2">
                    <Button
                        size="xs"
                        hover="gray"
                        color="gray"
                        callback={() => setFiltersIsOpen(!filtersIsOpen)}
                    >
                        <span className="mr-3">{buttonTexts.filterOpen}</span>
                        <img src="/icons/filter.svg" alt="filter" />
                    </Button>
                </div>
            </div>

            <Filters isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen} />
            <div className="flex flex-row-reverse pr-4 space-x-3 space-x-reverse">
                <Button
                    color="primary"
                    hover="primary"
                    size="xs"
                    callback={() => exportToExcelClick()}
                    loading={excelLoading}
                >
                    <img src="/icons/download.svg" alt="pushToExcel" />
                    <span className='ml-3'>{buttonTexts.exportToExcel}</span>
                </Button>
            </div>
            <RecordTable reportTableRef={reportTableRef} getHeadCells={handleHeadCells} />
        </div>
    );
}
export default CronJobRecords;










